export default "__VITE_ASSET__DLyhWMAR__"